'use client';

import { createContext, useCallback, useContext, useEffect, useState } from 'react';

/** Registers a request to hide the sidebar; the returned function withdraws it. */

const HideSidebarContext = createContext(() => () => {});
export const HideSidebarProvider = HideSidebarContext.Provider;

/** AppLayout side: the sidebar is hidden while any mounted page has asked for it (a count, so overlaps are safe). */
export const useHideSidebarRequests = () => {
  const [requests, setRequests] = useState(0);
  const requestHide = useCallback(() => {
    setRequests(count => count + 1);
    return () => setRequests(count => count - 1);
  }, []);
  return {
    isHiddenByPage: requests > 0,
    requestHide
  };
};

/**
 * Hides the app sidebar while the calling component is mounted and `hide` is true — for pages whose sidebar
 * depends on state, not the path (e.g. a job description opened by a guest from a shared link).
 */
export const useHideAppSidebar = (hide = true) => {
  const requestHide = useContext(HideSidebarContext);
  useEffect(() => hide ? requestHide() : undefined, [requestHide, hide]);
};